
import React from "react";
import { ShoppingCart } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Solution } from "@/types/solutions";

interface ShoppingCartProps {
  cart: Solution[];
  removeFromCart: (id: string) => void;
}

const ShoppingCartComponent: React.FC<ShoppingCartProps> = ({ cart, removeFromCart }) => {
  const getTotalPrice = () => {
    return cart.reduce((total, item) => total + item.price, 0);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <ShoppingCart className="h-4 w-4" />
          Your Cart
        </CardTitle>
      </CardHeader>
      <CardContent>
        {cart.length === 0 ? (
          <p className="text-sm text-gray-500">Your cart is empty</p>
        ) : (
          <div className="space-y-4">
            {cart.map((item) => (
              <div key={item.id} className="flex justify-between items-center text-sm border-b pb-2">
                <div>
                  <p className="font-medium">{item.title}</p>
                  <p className="text-gray-600">${item.price.toLocaleString()}</p>
                </div>
                <Button variant="ghost" size="sm" onClick={() => removeFromCart(item.id)}>
                  ×
                </Button>
              </div>
            ))}
            <div className="pt-2 border-t">
              <div className="flex justify-between font-medium">
                <span>Total:</span>
                <span>${getTotalPrice().toLocaleString()}</span>
              </div>
              <Button className="w-full mt-4">
                Checkout
              </Button>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default ShoppingCartComponent;
